<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    scrollable
    max-width="750"
    style="z-index: 6"
  >
    <v-form ref="editSupplierForm" @submit.prevent="submit">
      <v-card
        class="overflow-auto"
        :class="{ 'mobile-card': $vuetify.breakpoint.smAndDown }"
      >
        <v-card-title class="d-flex" style="vertical-align: middle">
          <v-row class="pa-3 mb-2">
            <h3 class="text--secondary">
              {{ $t("$vuetify.company.supplier") }}
            </h3>
            <v-spacer></v-spacer>
            <v-icon large @click="close">mdi-close</v-icon>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row class="justify-center">
            <v-col cols="12">
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    autofocus
                    :label="$t('$vuetify.formDetails.name')"
                    v-model="supplier.name"
                    :rules="[rules.req]"
                    class="uppercased-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                    :label="$t('$vuetify.formDetails.oib')"
                    v-model="supplier.oib"
                    :rules="[rules.req]"
                    class="uppercased-input "
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-select
                    label="Tip komunikacije"
                    :items="integrationTypes"
                    v-model="supplier.integration_type"
                    item-text="name"
                    item-value="value"
                    :rules="[rules.arrReq]"
                    small-chips
                    deletable-chips
                  ></v-select>
                </v-col>
              </v-row>
              <div v-if="supplier.integration_type === 'roto'" class="pb-3">
                <h3>Korisnički podaci potrebni za integraciju</h3>
              </div>
              <v-row v-if="supplier.integration_type === 'roto'">
                <v-col>
                  <v-text-field
                    :label="$t('$vuetify.formDetails.username')"
                    v-model="supplier.username"
                    :rules="[rules.req]"
                    class="uppercased-input"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    :label="$t('$vuetify.formDetails.password')"
                    v-model="supplier.password"
                    :rules="[rules.req]"
                    class="uppercased-input"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :label="$t('$vuetify.formDetails.country')"
                    :items="countries"
                    v-model="supplier.country"
                    item-text="country"
                    item-value="country"
                    :rules="[rules.req]"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    :label="$t('$vuetify.formDetails.address')"
                    v-model="supplier.address"
                    :rules="[rules.req]"
                    class="uppercased-input"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    :label="$t('$vuetify.formDetails.city')"
                    v-model="supplier.city"
                    :rules="[rules.req]"
                    class="uppercased-input"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    :label="$t('$vuetify.formDetails.zipCode')"
                    v-model="supplier.zip_code"
                    :rules="[rules.req]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    :label="$t('$vuetify.formDetails.phone')"
                    v-model="supplier.phone"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    :label="$t('$vuetify.formDetails.mobile')"
                    v-model="supplier.mobile"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Email"
                    v-model="supplier.email"
                    :rules="[rules.email]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    :label="$t('$vuetify.formDetails.supplierCode')"
                    v-model="supplier.code"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="IBAN"
                    v-model="supplier.iban"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Web"
                    v-model="supplier.web"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8">
                  <v-textarea
                    :label="$t('$vuetify.formDetails.additionalInfo')"
                    v-model="supplier.additional_info"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-5">
          <v-btn
            class="white--text okButton"
            height="45"
            :loading="submitting"
            :disabled="submitting"
            type="submit"
          >
            {{ $t("$vuetify.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { df, auth } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
import rules from '@/plugins/rules'
import state from '@/state'
import countries from '@/mixins/countries'
import requestChecker from '@/mixins/requestChecker'

export default {
  data: function (vm) {
    return {
      visible: false,
      submitting: false,
      rules: {
        req: rules.req(),
        oib: rules.oib(),
        email: rules.email(),
        arrReq: rules.arrReq()
      },
      supplier: {},
      selectedIntegrationTypes: [],
      integrationTypes: [
        // { name: 'Roto dinamic integracija', value: 'roto' }
        { name: 'Email', value: 'email' }
      ]
    }
  },
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  mixins: [countries, requestChecker],
  methods: {
    open (supplier) {
      this.visible = true
      this.submitting = false
      this.supplier = Object.assign(this.supplier, supplier)

      this.registerRequestParams(this.supplier)
    },
    close () {
      this.visible = false
    },
    removeOib (item) {
      this.supplier.oibs = this.supplier.oibs.filter((o) => o !== item)
      this.$forceUpdate()
    },
    submit () {
      const that = this
      if (!this.$refs.editSupplierForm.validate()) return
      this.submitting = true
      const reqId = uuidv4()

      const payload = {
        action: {
          operation: 'update',
          entity: 'supplier',
          resource_id: this.supplier.id,
          params: {
            company_id: state.getCurrentCompany().id,
            name: this.supplier.name.toLowerCase(),
            oibs: this.supplier.oibs.map((oib) => oib.trim()),
            address: this.supplier.address.toLowerCase(),
            city: this.supplier.city.toLowerCase(),
            zip_code: this.supplier.zip_code,
            country: this.supplier.country,
            code: this.supplier.code,
            integration_type: this.supplier.integration_type
          }
        }
      }

      if (this.supplier.integration_type === 'roto') {
        if (this.supplier.username && this.supplier.username !== '') {
          payload.action.params.username = this.supplier.username
        }
        if (this.supplier.password && this.supplier.password !== '') {
          payload.action.params.password = this.supplier.password
        }
      }

      if (this.supplier.additional_info) {
        payload.action.params = {
          ...payload.action.params,
          ...{ additional_info: this.supplier.additional_info }
        }
      }
      if (this.supplier.mobile) {
        payload.action.params = {
          ...payload.action.params,
          ...{ mobile: this.supplier.mobile }
        }
      }
      if (this.supplier.phone) {
        payload.action.params = {
          ...payload.action.params,
          ...{ phone: this.supplier.phone }
        }
      }
      if (this.supplier.email) {
        payload.action.params = {
          ...payload.action.params,
          ...{ email: this.supplier.email }
        }
      }
      if (this.supplier.web) {
        payload.action.params = {
          ...payload.action.params,
          ...{ web: this.supplier.web }
        }
      }
      if (this.supplier.iban) {
        let iban
        if (Array.isArray(this.supplier.iban)) {
          iban = this.supplier.iban
        } else {
          iban = [this.supplier.iban]
        }
        payload.action.params = { ...payload.action.params, ...{ iban: iban } }
      }

      const cleanParams = this.getCleanParams(this.supplier)
      Object.keys(cleanParams).forEach((key) => {
        if (key !== 'company_id' && key !== 'integration_type' && key !== 'username' && key !== 'password') {
          delete payload.action.params[key]
        }
      })

      try {
        df.doc(`request/${reqId}`)
          .set({
            user_id: `${auth.currentUser.uid}`,
            device_id: 'web',
            created: `${new Date().getTime()}`,
            type: 'supplier',
            payload: btoa(
              unescape(encodeURIComponent(JSON.stringify(payload)))
            )
          })
          .then(function () {
            that.$emit('successEdit', that.supplier)
            that.submitting = false
            that.visible = false
          })
          .catch(function (err) {
            that.showMsgBox({
              text: err && err !== '' ? err : 'An error has occurred',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
            that.submitting = false
          })
      } catch (err) {
        that.showMsgBox({
          text: err && err !== '' ? err : 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        that.submitting = false
      }
    }
  }
}
</script>
<style scoped>
.uppercased-input >>> input {
  text-transform: uppercase !important;
}
</style>
